import { useModal } from '../../../../../hooks/useModal';

export default function useIsCanInteractive({ highlightData: [highlightedItem] }) {
  const { modals } = useModal();
  return !highlightedItem && !modals?.length;
}
